import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    createdAtColumn: 'Created At',
    nameColumn: 'Name',
    updatedAtColumn: 'Updated At',
  },
})
